<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']">
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
      <li>
        <a>{{ deliveryNote?.number }}</a>
      </li>
    </ul>
  </div>

  @if (!deliveryNote) {
    <span class="bm-loading bm-loading-spinner"></span>
  } @else if (deliveryNote.status === "RECEIPT") {
    <a class="bm-btn bm-btn-disabled" disabled>
      <i class="fa fa-pencil"></i>
      Bearbeiten
    </a>
  } @else {
    <a [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'edit']" class="bm-btn">
      <i class="fa fa-pencil"></i>
      Bearbeiten
    </a>
    <button (click)="onDelete()" class="bm-btn bm-btn-error">
      <i class="fas fa-trash-alt"></i>
      Löschen
    </button>
  }
</div>

@if (deliveryNote) {
  <div class="page-content page-frame">
    <div class="page-sheet flex flex-col gap-4 h-full">
      <div class="flex-none">
        <ng-container *ngTemplateOutlet="tplNotes" />
      </div>

      <div class="flex-none flex flex-row gap-4">
        <ng-container *ngTemplateOutlet="tplInfos" />
        <ng-container *ngTemplateOutlet="tplShipcloud" />
      </div>

      <ag-grid-angular
        class="ag-theme-quartz flex-1 h-full"
        style="height: 300px; width: 100%"
        [theme]="hawkTheme"
        [loadThemeGoogleFonts]="true"
        [defaultColDef]="defaultColDef"
        [columnDefs]="colDefs"
        [rowClassRules]="rowClassRules"
        [rowSelection]="rowSelection"
        [localeText]="locale"
        [rowData]="articles"
        [alwaysShowVerticalScroll]="true"
      />
    </div>
  </div>
}

<ng-template #tplNotes>
  <ul class="flex flex-row gap-4">
    <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
      <h4 class="font-bold">Lieferschein</h4>
      <div class="flex-1 flex items-center justify-center"></div>
      <a class="bm-btn bm-btn-success bm-btn-block" [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'edit']">
        Bearbeiten
      </a>
      <a
        class="bm-btn bm-btn-success bm-btn-block"
        [href]="env.apiURL + 'delivery_notes/' + deliveryNote.id + '.pdf'"
        target="_blank"
      >
        <i class="fa fa-print mr6"></i>Drucken
      </a>
    </li>
    <!-- Block: Label START Here -->
    @if (deliveryNote.retoure) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash">
        <h4 class="font-bold">Label</h4>
      </li>
    } @else if (deliveryNote.status === "PREPARED") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Label</h4>
        <div class="flex-1 flex items-center justify-center"></div>
        <a
          class="bm-btn bm-btn-warning bm-btn-block"
          [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'shipping']"
        >
          Erstellen: Shipcloud
        </a>
        <a
          class="bm-btn bm-btn-warning bm-btn-block"
          href="/warehouse/deliveryNote/{{ deliveryNote.id }}/shippingOther"
        >
          Erstellen: Andere
        </a>
      </li>
    } @else if (!deliveryNote.retoure && deliveryNote.status !== "PREPARED") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Label</h4>
        <div class="flex-1 flex items-center justify-center">
          @if (deliveryNote.shipping_by === "SHIPCLOUD") {
            <span class="label label-default label-own">
              {{ deliveryNote.shipcloud_carrier }} - {{ deliveryNote.shipcloud_service }}
            </span>
          }
          @if (deliveryNote.shipping_by === "OTHER") {
            <span class="label label-default label-own">
              {{ deliveryNote.shipping_other_carrier }} - {{ deliveryNote.shipping_other_service }}
            </span>
          }
          @if (deliveryNote.shipping_by !== "SHIPCLOUD" && deliveryNote.shipping_by !== "OTHER") {
            <span class="white"> - </span>
          }
        </div>
        @if (deliveryNote.shipping_by === "SHIPCLOUD") {
          <a
            href="{{ deliveryNote.shipcloud_label_url }}"
            class="bm-btn bm-btn-block bm-btn-success mt-1"
            target="_blank"
          >
            <i class="fa fa-print"></i>Drucken
          </a>
        }
      </li>
    }
    <!-- Block: Label END Here -->

    <!-- Block: Retoure START Here -->
    @if (deliveryNote.related_note_id) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Retoure</h4>
        <div class="flex-1 flex items-center justify-center">
          <a [routerLink]="['/', 'retoure', deliveryNote.related_note_id]" class="white">
            {{ deliveryNote.related_note_number }}
          </a>
        </div>
        @if (deliveryNote.status === "PREPARED") {
          <a class="bm-btn bm-btn-block bm-btn-success" (click)="createRetoure()"> Neu erstellen </a>
        } @else {
          <a class="bm-btn bm-btn-block bm-btn-success"> Neu erstellen </a>
          <a
            class="bm-btn bm-btn-block bm-btn-success"
            [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'shipping-retoure']"
          >
            Shipcloud
          </a>
          <a class="bm-btn bm-btn-block bm-btn-success" href="javascript:;" (click)="createRetoure()"> Ohne Label </a>
        }
        @if (deliveryNote.shipcloud_retoure_shipcloud_id) {
          <a
            href="{{ deliveryNote.shipcloud_retoure_label_url }}"
            class="bm-btn bm-btn-block bm-btn-success mt-4"
            target="_blank"
          >
            <i class="fa fa-print mr6"></i>Drucken
          </a>
        }
      </li>
    } @else {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Retoure</h4>
        <div class="flex-1 flex items-center justify-center"></div>
        @if (deliveryNote.status === "PREPARED") {
          <a class="bm-btn bm-btn-block bm-btn-success" (click)="createRetoure()"> Erstellen </a>
        } @else {
          <a
            class="bm-btn bm-btn-block bm-btn-success"
            [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'shipping-retoure']"
          >
            Erstellen: Shipcloud
          </a>
          <a class="bm-btn bm-btn-block bm-btn-success" href="javascript:;" (click)="createRetoure()">
            Erstellen: Ohne Label
          </a>
        }
      </li>
    }
    <!-- Block: Retoure END Here -->

    <!-- Block: Pickup START Here -->
    @if (deliveryNote.retoure) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash">
        <h4 class="font-bold">Pickup</h4>
        <div class="flex-1 flex items-center justify-center">-</div>
      </li>
    } @else if (deliveryNote.status === "PREPARED") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Pickup</h4>
        <div class="flex-1 flex items-center justify-center">-</div>
      </li>
    } @else if (deliveryNote.shipcloud_pickup_id) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Pickup</h4>
        <div class="flex-1 flex flex-col items-center justify-center space-y-1">
          @if (deliveryNote.shipcloud_pickup_data.earliest) {
            <div>
              {{ deliveryNote.shipcloud_pickup_data.earliest | date: "dd.MM.yyyy HH:mm" }}
            </div>
          }
          @if (deliveryNote.shipcloud_pickup_data.latest) {
            <div>
              {{ deliveryNote.shipcloud_pickup_data.latest | date: "dd.MM.yyyy HH:mm" }}
            </div>
          }
        </div>
      </li>
    } @else if (["UPS", "DPD"].includes(deliveryNote.shipcloud_carrier)) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Pickup</h4>
        <div class="flex-1 flex items-center justify-center"></div>
        <a [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'pickup']" class="bm-btn bm-btn-block bm-btn-warning">
          Zeit festlegen
        </a>
      </li>
    } @else {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash">
        <h4 class="font-bold">Pickup</h4>
        <div class="flex-1 flex items-center justify-center">Funktioniert nur mit Shipcloud (UPS & DPD)</div>
      </li>
    }
    <!-- Block: Pickup END Here -->
    <!-- Block: Sendung START Here -->
    @if (deliveryNote.retoure) {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Sendung</h4>

        <div class="flex-1 flex items-center justify-center bm-join">
          <label class="bm-join-item bm-fieldset-label">
            @if (deliveryNote.related_note_id) {
              {{ deliveryNote.related_note_data.shipcloud_retoure_tracking_status }}
            } @else {
              Unbekannt
            }
          </label>
          <button
            [disabled]="isCheckingShipcloudTrackingStatus"
            class="bm-join-item bm-btn bm-btn-square"
            (click)="checkShipcloudTrackingStatus()"
          >
            <fa-icon [icon]="['fas', 'sync']" [class.fa-spin]="isCheckingShipcloudTrackingStatus" />
          </button>
        </div>

        <a
          href="{{ deliveryNote.shipcloud_retoure_tracking_url }}"
          class="bm-btn bm-btn-block bm-btn-warning mt-8"
          target="_blank"
        >
          Tracking
        </a>
      </li>
    } @else if (deliveryNote.status === "PREPARED") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Sendung</h4>
        <div class="flex-1 flex items-center justify-center">-</div>
      </li>
    } @else if (deliveryNote.shipping_by === "SHIPCLOUD") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Sendung</h4>

        <div class="flex-1 flex items-center justify-center bm-join">
          <label class="bm-join-item bm-fieldset-label">
            @if (deliveryNote.shipcloud_tracking_status) {
              {{ deliveryNote.shipcloud_tracking_status }}
            } @else {
              Unbekannt
            }
          </label>
          <button
            [disabled]="isCheckingShipcloudTrackingStatus"
            class="bm-join-item bm-btn bm-btn-square"
            (click)="checkShipcloudTrackingStatus()"
          >
            <fa-icon [icon]="['fas', 'sync']" [class.fa-spin]="isCheckingShipcloudTrackingStatus" />
          </button>
        </div>
        <a
          href="{{ deliveryNote.shipcloud_tracking_url }}"
          class="bm-btn bm-btn-block bm-btn-success mt-8"
          style="margin-top: 41px"
          target="_blank"
        >
          Tracking
        </a>
      </li>
    } @else if (deliveryNote.shipping_by === "OTHER") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Sendung</h4>
        <div class="flex-1 flex items-center justify-center">
          No: {{ deliveryNote.shipping_other_carrier_tracking_no }}
        </div>
      </li>
    } @else {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Sendung</h4>
        <div class="flex-1 flex items-center justify-center">-</div>
      </li>
    }

    <!-- Block: Sendung END Here -->
    <!-- Block: Empfang START Here -->
    @if (deliveryNote.status !== "RECEIPT") {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-warning">
        <h4 class="font-bold">Empfang</h4>
        <div class="text-center flex-1">-</div>
        <a
          [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'quittieren']"
          class="bm-btn bm-btn-block bm-btn-warning"
        >
          Quittieren
        </a>
      </li>
    } @else {
      <li class="flex-1 flex flex-col gap-2 bm-alert bm-alert-soft bm-alert-dash bm-alert-success">
        <h4 class="font-bold">Empfang</h4>
        <div class="text-center">quittiert am <br />{{ deliveryNote.receipt_date | date: "dd.MM.yyyy" }}</div>
      </li>
    }
    <!-- Block: Empfang END Here -->
  </ul>
</ng-template>

<ng-template #tplInfos>
  <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h2 class="bm-card-title">Absender</h2>
    <dl class="bm-dl">
      <dt>
        <!-- Firma -->
      </dt>
      <dd>{{ deliveryNote.sender_address_company || "-" }}</dd>

      <dt>
        <!-- Name -->
      </dt>
      <dd>{{ deliveryNote.sender_address_firstname }} {{ deliveryNote.sender_address_lastname }}</dd>

      <dt>
        <!-- Straße -->
      </dt>
      <dd>{{ deliveryNote.sender_address_street || "-" }} {{ deliveryNote.sender_address_street_no }}</dd>

      <dt>
        <!-- PLZ und Ort -->
      </dt>
      <dd>{{ deliveryNote.sender_address_zip }} {{ deliveryNote.sender_address_city }}</dd>

      <dt>
        <!-- Land (Staat) -->
      </dt>
      <dd>
        {{ deliveryNote.sender_address_country }}
        @if (deliveryNote.sender_address_state) {
          ({{ deliveryNote.sender_address_state }})
        }
      </dd>
    </dl>
  </section>
  <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h2 class="bm-card-title">Empfänger</h2>
    <dl class="bm-dl">
      <dt>
        <!-- Firma -->
      </dt>
      <dd>{{ deliveryNote.recipient_address_company || "-" }}</dd>

      <dt>
        <!-- Name -->
      </dt>
      <dd>{{ deliveryNote.recipient_address_firstname }} {{ deliveryNote.recipient_address_lastname }}</dd>

      <dt>
        <!-- Straße -->
      </dt>
      <dd>{{ deliveryNote.recipient_address_street || "-" }} {{ deliveryNote.recipient_address_street_no }}</dd>

      <dt>
        <!-- PLZ und Ort -->
      </dt>
      <dd>{{ deliveryNote.recipient_address_zip }} {{ deliveryNote.recipient_address_city }}</dd>

      <dt>
        <!-- Land (Staat) -->
      </dt>
      <dd>
        {{ deliveryNote.recipient_address_country }}
        @if (deliveryNote.recipient_address_state) {
          ({{ deliveryNote.recipient_address_state }})
        }
      </dd>
    </dl>
  </section>
  <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h2 class="bm-card-title">Lieferung</h2>
    <dl class="bm-dl">
      <dt>
        <!-- Nummer -->
      </dt>
      <dd>{{ deliveryNote.number }}</dd>

      <dt>
        <!-- Erstellt -->
      </dt>
      <dd>{{ deliveryNote.note_date | date: "dd.MM.yyyy" }}</dd>

      <dt>
        <!-- Auftrag (altes Feld) -->
      </dt>
      <dd>{{ deliveryNote.order_number || "-" }}</dd>

      <dt>
        <!-- Tickets -->
      </dt>
      <dd>
        @for (ticket of deliveryNote.tickets_data || []; track $index) {
          <div>
            <a [routerLink]="['/', 'ticket', ticket.id]" class="g-link d-flex align-items-center gap-2" target="_blank">
              <i class="fa fa-ticket mr6"></i>{{ ticket.external_order_nr || ticket.order_nr }}
            </a>
          </div>
        }
      </dd>

      <dt>
        <!-- Info -->
      </dt>
      <td>{{ deliveryNote.info }}</td>

      @if (mitgebArticles.length) {
        <dt>
          <!-- Mitgeb-Artikel -->
        </dt>
        <dd>
          <span class="font-semibold">Mitgeb-Artikel</span>
          <ul class="list-disc list-inside mt-1">
            @for (art of mitgebArticles; track $index) {
              <li>{{ art.found_quantity ?? art.quantity ?? 1 }}× {{ art.name }}</li>
            }
          </ul>
        </dd>
      }
    </dl>
  </section>
  <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h2 class="bm-card-title">Paket</h2>
    <dl class="bm-dl">
      <dt>
        <!-- Status -->
      </dt>
      <dd>
        @if (deliveryNote.status === "PREPARED") {
          <span class="label label-own label-default">Vorbereitet</span>
        }
        @if (deliveryNote.status === "SHIPPED") {
          <span class="label label-own label-warning">Versandt</span>
        }
        @if (deliveryNote.status === "DELIVERED") {
          <span class="label label-own label-success">Zugestellt</span>
        }
        @if (deliveryNote.status === "RECEIPT") {
          <span class="label label-own label-success">Quittiert</span>
        }
      </dd>

      @if (deliveryNote.parcel_height || deliveryNote.parcel_width || deliveryNote.parcel_length) {
        <dt>
          <!-- Paketmaße -->
        </dt>
        <dd>
          <span>
            {{ deliveryNote.parcel_height }} cm / {{ deliveryNote.parcel_width }} cm /
            {{ deliveryNote.parcel_length }} cm
            <span class="pull-right text-muted"> (H/B/L) </span>
          </span>
        </dd>
      }

      @if (deliveryNote.parcel_weight) {
        <dt>
          <!-- Gewicht -->
        </dt>
        <dd>{{ deliveryNote.parcel_weight }} kg</dd>
      }

      @if (deliveryNote.notification_email) {
        <dt>
          <!-- E-Mail -->
        </dt>
        <dd>
          {{ deliveryNote.notification_email || "-" }}
        </dd>
      }
    </dl>
  </section>
</ng-template>

<ng-template #tplShipcloud>
  @if (deliveryNote.shipping_by === "SHIPCLOUD") {
    <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
      <h2 class="bm-card-title">Shipcloud</h2>
      <dl class="bm-dl">
        <dt>
          <!-- Carrier -->
        </dt>
        <dd>
          <span class="font-bold">{{ deliveryNote.shipcloud_carrier }}</span>
          {{ deliveryNote.shipcloud_service }}
          @if (deliveryNote.shipcloud_test) {
            <span class="label label-own label-default pull-right"> Nur Test </span>
          }
        </dd>

        <dt>
          <!-- Sendung erstellt -->
        </dt>
        <dd>
          {{ deliveryNote.shipping_date | date: "dd.MM.yyyy" }}
        </dd>

        <dt>
          <!-- Carrier-Tracking -->
        </dt>
        <dd>{{ deliveryNote.shipcloud_carrier_tracking_no }}</dd>

        <dt>
          <!-- Tracking-URL -->
        </dt>
        <dd><a href="{{ deliveryNote.shipcloud_tracking_url }}" target="_blank">Tracking</a></dd>

        <dt>
          <!-- Preis: -->
        </dt>
        <dd>
          <span>{{ deliveryNote.shipcloud_price | currency: "€" }}</span>
        </dd>

        @if (deliveryNote.shipcloud_retoure_shipcloud_id) {
          <dt>
            <!-- Retoure-Label: -->
          </dt>
          <dd>Retoure-Label wurde erstellt</dd>
        } @else {
          <dt>
            <!-- Retoure-Label: -->
          </dt>
          <dd>
            <a [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'shipping-retoure']"> Retoure-Label erstellen </a>
          </dd>
        }
      </dl>
    </section>
    <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
      <h2 class="bm-card-title">Abholung</h2>
      <dl class="bm-dl">
        @if (deliveryNote.shipcloud_pickup_id) {
          <dt>
            <!-- Zeit: -->
          </dt>
          <dd>
            @if (deliveryNote.shipcloud_test) {
              <span class="label label-default label-own pull-right"> Nur Test </span>
            }
            {{
              deliveryNote.shipcloud_pickup_id && deliveryNote.shipcloud_pickup_data.earliest | date: "dd.MM.yyyy HH:mm"
            }}
            - <br />
            {{
              deliveryNote.shipcloud_pickup_id && deliveryNote.shipcloud_pickup_data.latest | date: "dd.MM.yyyy HH:mm"
            }}
          </dd>
          <dt>
            <!-- Adresse: -->
          </dt>
          <dd>
            <div>
              @if (deliveryNote.shipcloud_pickup_data.pickup_address_company) {
                {{ deliveryNote.shipcloud_pickup_data.pickup_address_company }},
              }
              @if (
                deliveryNote.shipcloud_pickup_data.pickup_address_firstname ||
                deliveryNote.shipcloud_pickup_data.pickup_address_lastname
              ) {
                {{ deliveryNote.shipcloud_pickup_data.pickup_address_firstname }}
                {{ deliveryNote.shipcloud_pickup_data.pickup_address_lastname }}
              }
            </div>
            <div>
              @if (
                deliveryNote.shipcloud_pickup_data.pickup_address_street ||
                deliveryNote.shipcloud_pickup_data.pickup_address_street_no
              ) {
                {{
                  [
                    deliveryNote.shipcloud_pickup_data.pickup_address_street,
                    deliveryNote.shipcloud_pickup_data.pickup_address_street_no,
                  ].join(" ")
                }},
              }

              @if (
                deliveryNote.shipcloud_pickup_data.pickup_address_city ||
                deliveryNote.shipcloud_pickup_data.pickup_address_zip
              ) {
                {{
                  [
                    deliveryNote.shipcloud_pickup_data.pickup_address_city,
                    deliveryNote.shipcloud_pickup_data.pickup_address_zip,
                  ].join(" ")
                }},
              }

              @if (deliveryNote.shipcloud_pickup_data.pickup_address_country) {
                {{ deliveryNote.shipcloud_pickup_data.pickup_address_country }}
              }
            </div>
          </dd>
          <dt>
            <!-- Telefon: -->
          </dt>
          <dd>
            {{ deliveryNote.shipcloud_pickup_data.phone || "-" }}
          </dd>
        } @else {
          <dt class="text-right text-muted">
            <!-- Abholung: -->
          </dt>
          @if (["UPS", "DPD"].includes(deliveryNote.shipcloud_carrier)) {
            <dd>
              <div>-</div>
              <div class="mt8 mb4 d-flex">
                <a
                  class="btn btn-default btn-block bg-white text-black btn-secondary col d-flex align-items-center gap-2 justify-content-center"
                  [routerLink]="['/', 'lieferscheine', deliveryNote.id, 'pickup']"
                >
                  <i class="fa fa-clock-o mr6"></i>Abholzeit festlegen
                </a>
              </div>
            </dd>
          } @else {
            <dd>Abholung nur mit UPS oder DPD möglich.</dd>
          }
        }
      </dl>
    </section>
  }
  @if (deliveryNote.shipping_by === "OTHER") {
    <section class="flex-1 bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
      <h2 class="bm-card-title">Anderer Versand</h2>
      <dl class="bm-dl">
        <dt>
          <!-- Carrier: -->
        </dt>
        <dd>
          <span class="bold">{{ deliveryNote.shipping_other_carrier }}</span>
          {{ deliveryNote.shipping_other_service }}
        </dd>

        <dt>
          <!-- Sendung erstellt: -->
        </dt>
        <dd>
          {{ deliveryNote.shipping_date | date: "dd.MM.yyyy" }}
        </dd>

        <dt>
          <!-- Carrier-Tracking: -->
        </dt>
        <dd>{{ deliveryNote.shipping_other_carrier_tracking_no }}</dd>

        <dt>
          <!-- Info: -->
        </dt>
        <dd>{{ deliveryNote.shipping_other_info }}</dd>

        <dt>
          <!-- Preis: -->
        </dt>
        <dd>
          @if (deliveryNote.shipping_other_price && deliveryNote.shipping_other_price >= 0) {
            {{ deliveryNote.shipping_other_price | currency: "€" }}
          } @else {
            -
          }
        </dd>
      </dl>
    </section>
  }
</ng-template>
